import "./BillingStatusToggle.css";

const BillingStatusToggle = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    className={`billing-status-toggle${checked ? " is-active" : ""}`}
    onClick={onChange}
    disabled={disabled}
    aria-pressed={checked}
  >
    <span className="billing-status-toggle__track">
      <span className="billing-status-toggle__thumb" />
    </span>
    <span className="billing-status-toggle__label">
      {checked ? "Active" : "Inactive"}
    </span>
  </button>
);

export default BillingStatusToggle;
